import { render, staticRenderFns } from "./OrganizationListAddNew.vue?vue&type=template&id=36d20d72&scoped=true"
import script from "./OrganizationListAddNew.vue?vue&type=script&lang=js"
export * from "./OrganizationListAddNew.vue?vue&type=script&lang=js"
import style0 from "./OrganizationListAddNew.vue?vue&type=style&index=0&id=36d20d72&prod&lang=scss"
import style1 from "./OrganizationListAddNew.vue?vue&type=style&index=1&id=36d20d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d20d72",
  null
  
)

export default component.exports